import { TextField } from '@refinedev/antd';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';

import LinkTextField from '@/components/general/LinkTextField';
import { ServiceOrderTypeString } from '@/model/ServiceOrder/ServiceOrder';
import { Ticket } from '@/model/Ticket/Ticket';

interface ServiceOrderShowWorkDetailProps {
  serviceOrder: any;
}

const ServiceOrderShowWorkDetail = (props: ServiceOrderShowWorkDetailProps) => {
  const { t } = useTranslation();
  const { serviceOrder } = props;

  return (
    <Card className="ServiceOrderShowSection">
      <div className="ServiceOrderShowTitle">{t('Detalles del trabajo realizado')}</div>
      <div className="ServiceOrderShowDataCard">
        <div className="ServiceOrderShowData">
          <b>{serviceOrder.tickets > 1 ? t('Tickets') : t('Ticket')}</b>
          <ul>
            {serviceOrder.tickets && serviceOrder.tickets.length > 0 ? (
              serviceOrder.tickets.map((ticket: Ticket | number) =>
                typeof ticket === 'number' ? (
                  <li key={ticket}>
                    <LinkTextField local to={`/tickets/show/${ticket}`} label={`${ticket}`} />
                  </li>
                ) : (
                  <li key={ticket.id}>
                    <LinkTextField
                      local
                      to={`/tickets/show/${ticket.id}`}
                      label={`${ticket.ticket_title_str} (${ticket.id.toString()})`}
                    />
                  </li>
                ),
              )
            ) : (
              <TextField value="-" />
            )}
          </ul>
        </div>
        <div className="ServiceOrderShowData">
          <b>{t('Tipo')}</b>
          <div>
            <TextField value={ServiceOrderTypeString[serviceOrder.type] ?? '-'} />
          </div>
        </div>

        <div className="ServiceOrderShowData">
          <b>{serviceOrder.moviles > 1 ? t('Maquinas involucradas') : t('Maquina involucrada')}</b>
          <ul>
            {serviceOrder.moviles && serviceOrder.moviles.length > 0 ? (
              serviceOrder.moviles.map((movil: any) => (
                <li key={movil.id}>
                  <LinkTextField
                    admin
                    to={`/serveradmin/movil/${movil.id}`}
                    label={`${movil.description} (${movil.id})`}
                  />
                </li>
              ))
            ) : (
              <TextField value="-" />
            )}
          </ul>
        </div>
        {serviceOrder.delivery_note_links && serviceOrder.delivery_note_links.length > 0 && (
          <div className="ServiceOrderShowData">
            <b>
              {serviceOrder.delivery_note_links.length > 1
                ? t('Números de remito')
                : t('Número de remito')}
            </b>
            <ul>
              {serviceOrder.delivery_note_links && serviceOrder.delivery_note_links.length > 0 ? (
                serviceOrder.delivery_note_links.map((link: string, index: number) => (
                  <li key={index}>
                    <LinkTextField
                      admin
                      to={link}
                      label={
                        link.split('source_code=')[1] ?? `${t('Número de remito')} ${index + 1}`
                      }
                    />
                  </li>
                ))
              ) : (
                <TextField value="-" />
              )}
            </ul>
          </div>
        )}
      </div>

      <div className="ServiceOrderShowData" style={{ marginTop: 12 }}>
        <b>{t('Descripción')}</b>
        <div>
          <TextField value={serviceOrder.description ?? '-'} />
        </div>
      </div>
    </Card>
  );
};

export default ServiceOrderShowWorkDetail;
